import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const frameToolUiEvents = eventGroup({
  source: 'Frame Tool UI',
  events: {
    graphFocusRequested: type<{ frameId: string }>(),
  },
});
